/*globals google*/
/*jshint camelcase: false */
(function () {
    'use strict';

    angular
        .module('invesfleet')
        .directive('googlePlaces', googlePlaces);

    googlePlaces.$inject = ['$timeout'];

    function googlePlaces($timeout) {
        // Usage:
        //     <input google-places ng-model="vm.dir" country="vm.country" state="vm.state" city="vm.city">

        var directive = {
            require: 'ngModel',
            link: link,
            restrict: 'A',
            scope: {
                ngModel: '=',
                country: '=?',
                state: '=?',
                city: '=?',
                cp: '=?',
                lat: '=?',
                long: '=?',
                onChange: '&?',
                onAddressChange: '&?',
                autocomplete: '=?'
            }
        };
        return directive;

        function link(scope, element, attrs, model) {

            //GOOGLE AUTOCOMPLETE SIN GOOGLE PLACES
                        
            var CALL_DELAY = 300; //Milisegundos que deben pasar sin input para hacer la llamada
            var MIN_LETTERS = 4; //Número mínimo de letras que debe tener la dirección para buscar

            var suggestionBox = null;
            var selectedSuggestion = -1;
            var suggestionItems = [];
            var poweredByGoogle = null;

            element.attr('placeholder', 'Introduce una ubicación');

            function selectAddress(info){
                var country, state, city, cp, streetNumber;
                
                var addressComponents = info.address_components;
                
                angular.forEach(addressComponents, function(value, key) {
                    switch (value.types[0]) {
                        case 'street_number':
                            streetNumber = value.long_name.toString();
                            break;
                        case 'locality': //city
                            city = value.long_name;
                            break;
                        case 'administrative_area_level_2': //state
                            state = value.long_name;
                            break;
                        case 'country': //country
                            country = value.long_name;
                            break;
                        case 'postal_code': //cp
                            cp = value.long_name;
                            break; 
                    }
                });
                scope.ngModel = info.formatted_address.toString().split(',')[0] + 
                (streetNumber ? ', ' + streetNumber : '');

                if(scope.autocomplete){
                    scope.country = country;
                    scope.state = state;
                    scope.city = city;
                    scope.cp = cp;
                }
                
                if(info.geometry){
                    scope.lat = info.geometry.location.lat();
                    scope.long = info.geometry.location.lng();
                }
                
                model.$setViewValue(element.val());
                $timeout(function () {
                    if (scope.onChange) { scope.onChange(); }
                    if (scope.onAddressChange) {
                        scope.onAddressChange({
                            address: {
                                city: city,
                                state: state,
                                country: country,
                                cp: cp,
                                lat: scope.lat,
                                lng: scope.long
                            }
                        });
                    }
                }, 0);
            }

            var delay = (function () {
                var timer = 0;
                return function (callback, ms) {
                    clearTimeout(timer);
                    timer = setTimeout(callback, ms);
                };
            })();

            function addSuggestionBox() {
                suggestionBox = angular.element('<div class="suggestion-box"></div>');

                var rect = element[0].getBoundingClientRect();

                suggestionBox.css('width', rect.width + 'px');
                suggestionBox.css('top', rect.height + 'px');
                suggestionBox.css('left', element[0].offsetLeft + 'px');

                element[0].after(suggestionBox[0]);
            }

            function addSuggestionItem(info) {
                if(suggestionBox == null){return;}
                var suggestionItem = angular.element(
                    '<div class="suggestion">' +
                        '<i class="icon icon-010"></i>' + 
                        info.formatted_address + 
                    '</div>');

                var rect = element[0].getBoundingClientRect(); 

                suggestionItem.css('height', 30 + 'px');
                suggestionItem.css('line-height', 30 + 'px');

                suggestionItem.on('mousedown', function () {
                    selectAddress(info);
                });
                suggestionItem.data = info;
                suggestionItems.push(suggestionItem);

                suggestionBox.append(suggestionItem);
            }

            function addPoweredByGoogle() {
                if(suggestionBox == null){return;}
                poweredByGoogle = angular.element(
                    '<img class="img-google" align="right" ' +
                    'src="https://maps.gstatic.com/mapfiles/api-3/images/powered-by-google-on-white3.png" ' +
                    'alt="Powered by Google">');
                suggestionBox.append(poweredByGoogle);
            }

            function clearSuggestions() {
                angular.forEach(suggestionItems, function (value, key) {
                    value.remove();
                });
                if(poweredByGoogle){
                    poweredByGoogle.remove();
                }
                suggestionItems = [];
            }

            function geocode() {
                delay(function () {
                    var geocoder = new google.maps.Geocoder();
                    geocoder.geocode({ 'address': scope.ngModel }, function (results, status) {
                        if (status === google.maps.GeocoderStatus.OK) {
                            selectedSuggestion = -1;
                            clearSuggestions();
                            for (var i = 0; i < results.length; i++) {
                                addSuggestionItem(results[i]);
                            }
                            addPoweredByGoogle();
                        } 
                    });
                }, CALL_DELAY);
            }

            function selectSuggestion(index){
                if(selectedSuggestion >= 0 && selectedSuggestion < suggestionItems.length){
                    suggestionItems[selectedSuggestion].removeClass('selected');
                }
                if(index >= 0 && index < suggestionItems.length){
                    suggestionItems[index].addClass('selected');
                }
                selectedSuggestion = index;
            }

            element.on('focus', function () {
                addSuggestionBox();
                if (scope.ngModel && scope.ngModel.length >= MIN_LETTERS) {
                    geocode();
                }
            }); 

            element.on('blur', function () {
                if(selectedSuggestion >= 0 && selectedSuggestion < suggestionItems.length){
                    selectAddress(suggestionItems[selectedSuggestion].data);
                }
                suggestionBox.remove();
                suggestionBox = null;
                suggestionItems = []; 
                selectedSuggestion = -1; 
            }); 

            element.on('keydown', function (evt) {
                switch(evt.keyCode){
                    case 40: //ARROW DOWN
                        var nextSelected = selectedSuggestion + 1;
                        if(nextSelected >= suggestionItems.length){
                            nextSelected = -1; //None selected
                        }
                        selectSuggestion(nextSelected);
                        break;

                    case 38: //ARROW UP
                        nextSelected = selectedSuggestion - 1;
                        if(nextSelected < -1){
                            nextSelected = suggestionItems.length - 1; //Jump to last
                        }
                        selectSuggestion(nextSelected);
                        break;
                    
                    case 13: //ENTER
                        if(suggestionBox && suggestionItems.length > 0 && selectedSuggestion !== -1){
                            selectAddress(suggestionItems[selectedSuggestion].data);
                            suggestionBox.remove();
                        }
                        break;
                }
            });

            element.on('keyup', function (evt) {
                if(evt.keyCode === 40 || evt.keyCode === 38 || evt.keyCode === 13){ return; }

                if (scope.ngModel && scope.ngModel.length >= MIN_LETTERS) {
                    geocode();
                } else {
                    clearSuggestions();
                }
            });


            /*
            AUTOCOMPLETE USANDO GOOGLE PLACES
            Dejar por si se contrata esa API algún día

            var geolocation = false;
            var options = {
                types: [],
                //componentRestrictions: {}
            };
            
            scope.gPlace = new google.maps.places.Autocomplete(element[0], options);

            google.maps.event.addListener(scope.gPlace, 'place_changed', function() {
                var geoComponents = scope.gPlace.getPlace();
                var country, state, city, cp;
                
                var addressComponents = geoComponents.address_components;
                angular.forEach(addressComponents, function(value, key) {
                    switch (value.types[0]) {
                        case 'locality': //city
                            city = value.long_name;
                            break;
                        case 'administrative_area_level_1': //state
                            state = value.long_name;
                            break;
                        case 'country': //country
                            country = value.long_name;
                            break;
                        case 'postal_code': //cp
                            cp = value.long_name;
                            break; 
                    }
                });
                scope.$apply(function() {
                    scope.country = country;
                    scope.state = state;
                    scope.city = city;
                    scope.cp = cp;
                    if(geoComponents.geometry){
                        scope.lat = geoComponents.geometry.location.lat();
                        scope.long = geoComponents.geometry.location.lng();
                    }
                    geolocation = true;
                    model.$setViewValue(element.val());
                });
            });
            */

        }
    }
})(); 